<template>
    <v-dialog v-model="dialog" scrollable :max-height="maxHeight" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : maxWidth" persistent>
        <v-card>
                <v-card-title class="ma-0 pa-0">
                    <v-app-bar dense :height="height" :class="color + ' mb-4 elevation-1'">
                        <v-icon left>{{ icon }}</v-icon>
                            <v-toolbar-title class="subtitle-1">
                                <slot name="title">{{ title }}</slot>
                            </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <slot name="tools"></slot>
                        <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small class="mr-1" @click.native="dialog = false" :disabled="disabled" v-bind="attrs" v-on="on">
                                        <v-icon color="red lighten-2">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Fechar</span>
                        </v-tooltip>
                    </v-app-bar>
                </v-card-title>

                <v-card-text class="pt-0">

                    <SysTeacherConfirmedTimes 
                        v-for="(grid, index) in grids" 
                        :key="index" 
                        hide-joins 
                        :workTime="acesso.periodo" 
                        :grid="grid" 
                    />


                </v-card-text>
                
                <v-btn color="primary" @click.prevent.stop="dialog = false">Fechar</v-btn>

            </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "SysTeacherConfirmedTimesList",
    data: () => ({
        dialog: false,
    }),
    created(){
        var vm = this
        document.addEventListener('keyup', function (evt) {
            if (evt.keyCode === 27) {
                vm.dialog = false
            }
        });
    },
    computed: {
    ...mapState('auth', ['acesso']),
    },
    watch: {
        
        dialog() {
            this.$emit('update:show', this.dialog);
        },

        show(val) {
            this.dialog = val;
        },
    },
    props: {
        grids: {
            required: true
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        height: {
            type: String,
            default: "45"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        maxHeight:{
            type: String,
            default: "auto"
        },
        icon: {
            type: String,
            default: "mdi-calendar-clock"
        },
        title: {
            type: String,
            default: "Horários da Grade"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        
        save(){
            this.$emit('onSave', this.edit);
        },

    }
}
</script>